import CouponError from './CouponsError';
class InvalidInvestorId extends CouponError {
    constructor(options) {
        super('The client id is not in uuid format', options);
    }
}
export default InvalidInvestorId;
